import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import Balloon from '../game/Balloon';
import BalloonContainer from '../game/BalloonContainer';
import MrBee from '../game/MrBee';
import QuestionMaker from '../game/QuestionMaker';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import ClickPointCircle from '../ui/ClickPointCircle';
import GameHUDHeader from '../ui/GameHUDHeader';
import QuestionDisplay from '../ui/QuestionDisplay';
import UIAssetKeys from '../UIAssetKeys';
import ResultsScreen from './ResultsScreen';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  init() {
    this.curRound = 1;
    this.curQuestion = 0;

    this.hud = null;
    this.question = null;
    this.questionDisplay = null;
    this.clickDisplay = null;

    this.questionMaker = null;

    this.mrbee = null;
    this.stingOffsetX = 30;
    this.stingOffsetY = 45;

    this.balloonContainer = null;

    /** @type {Balloon[]} */
    this.balloons = null;
    this.activeBalloons = null;

    this.clickArea = null;

    this.uibusy = true;
    this.questionCount = 10;
    this.userResults = null;

    this.curColor = 2;

    this.beeIdleTime = 0;
    this.beeIdleWaitTime = 6000;
  }

  create() {
    this.bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._MainBackground, this).setOrigin(0);

    this.clickArea = this.add.zone(0,0,this.scale.width, this.scale.height - 180).setOrigin(0)
      .setInteractive();
    this.clickArea.workingWidth = this.scale.width;
    this.clickArea.workingHeight = this.scale.height - 180;

    this.curRound = gameData.gameInfo.currentRound;

    let minNum = 0; let maxNum = 7;
    switch (this.curRound) {
      case 1:
        maxNum = 7;
        break;
      case 2:
        minNum = 1;
        maxNum = 12;
        break;
      case 3:
        minNum = 1;
        maxNum = 20;
        break;
    }

    this.questionMaker = new QuestionMaker(minNum, maxNum);

    this.hud = new GameHUDHeader(this, this.curRound);
    this.add.existing(this.hud);

    this.questionDisplay = new QuestionDisplay(this);
    const os = -180;
    this.questionDisplay.y = this.scale.height + os;

    this.hill = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._Hill, this).setOrigin(0);

    /** @type {Balloon[]} */
    this.activeBalloons = [];
    this.initBalloons(maxNum * 2 + 1);

    this.hill.y = this.scale.height - this.hill.height;

    this.children.bringToTop(this.hill);
    this.add.existing(this.questionDisplay);
    this.initBee();

    this.clickDisplay = new ClickPointCircle(this);
    this.clickDisplay.x = -200;
    this.clickDisplay.y = -200;
    this.add.existing(this.clickDisplay);

    // prep data store
    this.userResults = [];
    this.initRound();
  }

  checkAnswer () {
    if (this.uibusy) return;
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
    this.uibusy = true;
    const remaining = this.countAliveBalloons();
    this.questionDisplay.beginFeedbackDisplay(this.question, remaining);
  }

  countAliveBalloons () {
    let remaining = 0;
    for (let i = 0; i < this.activeBalloons.length; i++) {
      if (this.activeBalloons[i].isAlive) remaining++;
    }
    return remaining;
  }

  nextQuestion () {
    this.floatRemainingBalloons();

    // get the current data before we up the question
    this.curQuestion++;
    if (this.curQuestion <= this.questionCount) {
      this.loadQuestion();
    }
    else {
      const resultsStore = gameData.userData.roundResults[gameData.gameInfo.currentRound - 1];
      resultsStore.questionResults = this.userResults;

      // figure out score
      const total = this.userResults.length;
      let incorrect = 0;
      for (let i = 0; i < total; i++) {
        if (this.userResults[i].attempts > 1) {
          incorrect++;
        }
      }
      resultsStore.incorrectCount = incorrect;
      resultsStore.totalCount = total;
      this.outro();
      return;
    }
    this.uibusy = false;
  }

  floatRemainingBalloons () {
    const len = this.activeBalloons.length - 1;
    let b = null;
    for (let i = len; i >= 0; i--) {
      b = this.activeBalloons[i];
      if (b.isAlive) {
        b.isAlive = false;

        b.initMoveTo(b.pos.x + Phaser.Math.Between(1,80), -320, 4);
      }
    }
  }

  loadQuestion () {
    this.hud.turnOnIndicator(this.curQuestion - 1);
    this.question = this.questionMaker.getQuestion();

    this.userResults.push({});
    this.userResults[this.curQuestion - 1].questionString = `${this.question.num1}-${this.question.num2}=${this.question.answer}`;
    this.userResults[this.curQuestion - 1].attempts = 1;

    this.questionDisplay.setQuestion(this.question);
    let c = Phaser.Math.Between(1,5);
    if (c === this.curColor) {
      c++;
      if (c > 5) c = 1;
    }
    this.curColor = c;
    let pt = null; let b = null;

    this.balloonWorld.resetPool();
    let num = this.question.num1; // make sure there's at least 1 to pop
    if (num === 0) num = 1;
    for (let i = 0; i < num; i++) {
      pt = this.balloonWorld.getSpot();
      b = this.balloons.pop();
      b.pos.x = pt.x - Phaser.Math.Between(1,4);
      b.x = b.pos.x;
      b.pos.y = this.scale.height - this.hill.height + Phaser.Math.Between(150,180);
      b.y = b.pos.y;
      b.reset(b.x, b.y, this.curColor);
      b.initFloatTo(pt.x, pt.y);
      this.activeBalloons.push(b);
    }
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._whistle_up, this);
  }

  outro () {
    this.floatRemainingBalloons();
    ABCyaPhaser.Tweens.addTween(this.questionDisplay, 440, { alpha: 0 }, Phaser.Math.Easing.Linear);
    this.hud.alpha = 0;

    this.mrbee.off('ARRIVED');
    this.mrbee.off('STING');

    this.mrbee.initMoveTo(this.scale.width + 600, this.mrbee.pos.y + Phaser.Math.Between(1,60), 60);
    this.time.delayedCall(1111, this.nextScene, null, this);
  }

  nextScene () {
    this.scene.start(ResultsScreen.KEY, { resultType: 'QUESTIONS' });
  }

  retryQuestion () {
    this.userResults[this.curQuestion - 1].attempts += 1;

    // see how many balloons are left
    const remaining = this.countAliveBalloons();

    // bring in whatever they popped
    let needed = this.question.num1 - remaining;
    if (needed > this.question.num1) needed = 0;
    this.addBalloons(needed);

    // unlockui
    this.uibusy = false;
  }

  addBalloons (num) {
    let pt = null; let b = null;
    for (let i = 0; i < num; i++) {
      pt = this.balloonWorld.getSpot();
      b = this.balloons.pop();
      b.pos.x = pt.x - Phaser.Math.Between(1,4);
      b.x = b.pos.x;
      b.pos.y = this.scale.height - this.hill.height + Phaser.Math.Between(150,180);
      b.y = b.pos.y;
      b.reset(b.x, b.y, this.curColor);
      b.initFloatTo(pt.x, pt.y);
      this.activeBalloons.push(b);
    }
  }

  initBalloons (num) {
    this.balloonWorld = new BalloonContainer(this);
    this.add.existing(this.balloonWorld);
    this.balloonContainer = this.add.container();
    this.balloons = [];
    let x = 0; let y = 0;
    const len = num; let b = null;
    for (let i = 0; i < len; i++) {
      x = this.scale.width / 2;
      y = this.scale.height - this.hill.height + Phaser.Math.Between(150,180);
      b = new Balloon(this, this.balloonWorld, x, y);
      b.balloonTop.on('BALLOON_FINISHED', this.balloonSelfRemove, this);
      b.pos.x = x;
      b.pos.y = y;
      this.balloons.push(b);
    }
  }

  balloonSelfRemove (e) {
    e.balloon.hide();
    this.deactivateBalloon(e.balloon);
  }

  deactivateBalloon (item) {
    const index = this.activeBalloons.indexOf(item);
    const b = this.activeBalloons.splice(index,1);
    if (b.length >= 1) {
      this.balloons.push(item);
    }
  }

  initBee () {
    this.mrbee = new MrBee(this, true);
    const mrBeeBounds = this.mrbee.getBounds();
    this.mrbee.list.forEach((child) => {
      child.setPosition(child.x - mrBeeBounds.width / 2, child.y - mrBeeBounds.height / 2);
    });
    this.mrbee.setPosAndAttractor(-100,450,-3,-3);
    this.mrbee.x = -1000;
    this.mrbee.y = -1000;
    this.mrbee.turn(-1);
    this.add.existing(this.mrbee);
  }

  initRound () {
    this.curQuestion = 1;

    if (gameData.gameInfo.currentRound === 1) {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._QuestionInstructions, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    else {
      ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._vo_lets_try_a_harder, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    }
    if (!gameData.gameInfo.playedInstructions) {
      gameData.gameInfo.playedInstructions = true;
      this.beginInstruct();
      this.questionDisplay.beginShowQuestion();
    }
    else {
      this.mrbee.on('ARRIVED', this.beeAtPoint, this);
      this.mrbee.on('STING', this.beeStingOver, this);
      this.mrbee.initMoveTo(100,this.scale.height - 200);
      this.startRound();
      this.questionDisplay.beginShowQuestion();
    }
  }

  beginInstruct () {
    this.bringInstructBalloon();
    let i = Phaser.Math.Between(1,this.activeBalloons.length);
    i -= 1;
    this.balloonWorld.balloonToPop = this.activeBalloons[i];
    const dest = this.activeBalloons[i].attractor;
    this.helpHand = ABCyaPhaser.Images.addImage(dest.x - this.stingOffsetX,dest.y,UIAssetKeys._Hand_Pointer, this).setOrigin(0);
    this.helpHand.alpha = 0;
    this.helpHand.scale = 1.2;

    ABCyaPhaser.Tweens.addTween(this.helpHand, 400, { delay: 1500, alpha: 1, scale: 0.9 }, Phaser.Math.Easing.Linear, () => {
      this.instructBeeBring();
      ABCyaPhaser.Tweens.addTween(this.helpHand, 300, { delay: 500, alpha: 0, scale: 1.2 }, Phaser.Math.Easing.Linear);
    });
  }

  bringInstructBalloon () {
    const cnt = 2; let b = null;
    const starty = 600;
    const pts = [{ x: 400, y: 200 }, { x: 600, y: 180 }];
    for (let i = 0; i < cnt; i++) {
      b = this.balloons.pop();
      b.pos.x = pts[i].x - Phaser.Math.Between(1,4);
      b.x = b.pos.x;
      b.y = starty;
      b.reset(b.x, b.y);
      b.initFloatTo(pts[i].x, pts[i].y);
      this.activeBalloons.push(b);
    }
  }

  instructBeeBring () {
    this.beeIdleTime = 0;
    this.mrbee.once('ARRIVED', this.popInstructBalloon, this);
    this.mrbee.initMoveTo(this.balloonWorld.balloonToPop.attractor.x + this.stingOffsetX, this.balloonWorld.balloonToPop.attractor.y - this.stingOffsetY);
  }

  popInstructBalloon () {
    this.beeIdleTime = 0;
    this.mrbee.once('STING', this.instructStingFinished, this);
    this.mrbee.doSting();
    this.balloonWorld.balloonToPop.pop();
    this.balloonWorld.balloonToPop = null;
  }

  instructStingFinished () {
    this.mrbee.initForceMove(this.mrbee.pos.x - Phaser.Math.Between(2,4), this.mrbee.pos.y - Phaser.Math.Between(2,4));
    this.helpHand.x = 780;
    this.helpHand.y = this.scale.height - 140;

    ABCyaPhaser.Tweens.addTween(this.helpHand, 400, { alpha: 1, scale: 0.9 }, Phaser.Math.Easing.Linear, () => {
      this.instructShowAnswer();
      ABCyaPhaser.Tweens.addTween(this.helpHand, 300, { delay: 500, alpha: 0, scale: 1.2 }, Phaser.Math.Easing.Linear);
    });
  }

  instructShowAnswer () {
    this.questionDisplay.setAnswer(1);
    this.time.delayedCall(500, this.showInstructFeedback, null, this);
  }

  showInstructFeedback () {
    this.floatRemainingBalloons();
    this.questionDisplay.showCorrect(true);
    this.mrbee.on('ARRIVED', this.beeAtPoint, this);
    this.mrbee.on('STING', this.beeStingOver, this);
    this.mrbee.initMoveTo(100,this.scale.height - 200);
    this.time.delayedCall(800, this.startRound,null, this);
  }

  startRound () {
    this.beeIdleTime = 0;
    this.clickArea.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.clickScreen, this);
    this.loadQuestion();
    this.uibusy = false;
  }

  clickScreen (pointer) {
    if (this.uibusy) return;
    this.beeIdleTime = 0;
    const x = pointer.x;
    const y = pointer.y;
    let destX = x;
    let destY = y;

    // check for a balloon hit
    const len = this.activeBalloons.length;
    let found = false;
    this.balloonContainer.balloonToPop = null;
    for (let i = 0; i < len; i++) {
      if (this.activeBalloons[i].isAlive && this.activeBalloons[i].checkHit(x,y)) {
        this.balloonWorld.balloonToPop = this.activeBalloons[i];
        destX = this.activeBalloons[i].pos.x;
        destY = this.activeBalloons[i].pos.y - this.stingOffsetY;
        const dir = this.mrbee.pos.x - this.activeBalloons[i].pos.x;
        if (dir < 0) {
          destX += this.stingOffsetX;
        }
        else {
          destX -= this.stingOffsetX;
        }
        found = true;
        break;
      }
    }
    if (!found) {
      this.balloonWorld.balloonToPop = null;
    }
    this.mrbee.initMoveTo(destX, destY, 60);
    this.clickDisplay.displayClick(pointer.x, pointer.y);
  }

  beeAtPoint () {
    if (this.balloonWorld.balloonToPop) {
      this.balloonWorld.balloonToPop.pop();
      this.balloonWorld.balloonToPop = null;
      this.mrbee.doSting();
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._balloon_expand, this);
    }
    else {
      this.mrbee.initForceMove(this.mrbee.pos.x + Phaser.Math.Between(5,10) - 10, this.mrbee.pos.y + Phaser.Math.Between(5,10) - 10);
    }
  }

  beeStingOver () {
    this.mrbee.initForceMove(this.mrbee.pos.x, this.mrbee.pos.y);
  }

  update (time, delta) {
    const deltaSeconds = delta / 1000;
    this.mrbee.tick(deltaSeconds);
    if (this.beeIdleTime > this.beeIdleWaitTime) {
      let x = Phaser.Math.Between(10, 200) - 100;
      let y = Phaser.Math.Between(10, 200) - 100;
      x = x + this.mrbee.pos.x;
      y = y + this.mrbee.pos.y;
      if (x < 100) x = 100;
      if (y < 100) y = 100;
      if (x > this.clickArea.workingWidth - 100) x = this.clickArea.workingWidth - 100;
      if (y > this.clickArea.workingHeight - 50) y = this.clickArea.workingHeight - 50;
      this.mrbee.initForceMove(x,y);
      if (x - this.mrbee.pos.x > 0) {
        this.mrbee.turn(-1);
      }
      else {
        this.mrbee.turn(1);
      }
      this.beeIdleTime = 0;
    }
    else {
      this.beeIdleTime += delta;
    }
    const len = this.activeBalloons.length - 1;
    for (let i = len; i >= 0; i--) {
      if (!this.activeBalloons[i].isActive) {
        this.deactivateBalloon(this.activeBalloons[i]);
        continue;
      }
      this.activeBalloons[i].tick(deltaSeconds);
    }
  }
}